module.exports = __webpack_public_path__ + "03_veryshort_gold.5be33e29.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/03_veryshort_gold.png
// module id = jVHR
// module chunks = 0